





























































































































































import {Component} from 'vue-property-decorator';
import GenericDistribution from '@/pages/Pages/Distributions/GenericDistribution.vue'
import PushTemplate from '@/pages/Pages/Templates/PushTemplate.vue'
import PushFilters from '@/components/Distributions/PushFilters.vue'
import { MsgTransports } from '@/store/types';
import { Getter } from 'vuex-class';
import { SelectWings } from "wings-ui-components";

@Component({components: {GenericDistribution, PushTemplate, PushFilters, SelectWings}})
export default class PushDistribution extends GenericDistribution {

  @Getter("pushOSVersions") pushOSVersionsList: any;
  @Getter("pushSDKVersions") pushSDKVersionsList: any;
  @Getter("pushMappVersions") pushMappVersionsList: any;
  @Getter("pushApplications") applicationsList: any;
  @Getter("pushGroupApplications") groupApplicationsList: any;

  transport = MsgTransports.PUSH

  applicationsName(ids: number[], type: string) {
    if (type === 'applications'){
      return this.applicationsList.filter((item: any) => ids
          .includes(item.applicationId))
          .map((el: any) => el.appName).join(', ');
    }
    return this.groupApplicationsList.filter((item: any) => ids
        .includes(item.id))
        .map((el: any) => el.name).join(', ');
  }

  getAppName(value: number): string {
    if (value === 1) return this.$tc('values.applications.all');
    else return this.$tc('values.applications.last_created');
  }

  getAppSelectionRule(value: number): string {
    if (value === 1) return this.$tc('values.applications.all');
    if (value === 2) return this.$tc('values.applications.by_priority');
    else return this.$tc('values.applications.last_created');
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    this.beforeLeave(to,from,next)
  }

  get getOSVersionsNames() {
    return (this.pushOSVersionsList && this.pushOSVersionsList[0])
            ? this.pushOSVersionsList[0]?.versions.filter((item:any) => this.pushFilter.os_version_ids.includes(item.id)).map((item:any) => item.version)
            : []
  }

  get getSDKVersionsNames() {
    return this.pushSDKVersionsList.filter((item:any) => this.pushFilter.sdk_ids.includes(item.id)).map((item:any) => item.version)
  }

  get getMappVersionsNames() {
    return (this.pushMappVersionsList && this.pushMappVersionsList[0])
            ? this.pushMappVersionsList[0]?.versions.filter((item:any) => this.pushFilter.mapp_ids.includes(item.id)).map((item:any) => item.version)
            : []
  }

}
